// extracted by mini-css-extract-plugin
export default {"access-product-link":"digital-product_access-product-link__6+mUm","link-label":"digital-product_link-label__+ySPt"};